import { ReactNode, useEffect } from "react";
import { Keyboard, KeyboardResize } from "@capacitor/keyboard";
import { Button, Colors, Icon } from "swing-components";

import { AlertError } from "~components";

import "./ModalSubProfileEdit.css"; // Note .css as ionic overrides needed

type ModalSubProfileEditProps = {
  children: ReactNode;
};

export function ModalSubProfileEdit(props: ModalSubProfileEditProps) {
  const { children } = props;

  useEffect(() => {
    Keyboard.setResizeMode({ mode: KeyboardResize.Native });

    return () => {
      Keyboard.setResizeMode({ mode: KeyboardResize.None });
    };
  }, []);

  return <div className="modal-wrapper">{children}</div>;
}

type ModalSubProfileEditHeaderProps = {
  onDismiss: (data?: string | number, role?: string) => void;
  title: string;
};

export function ModalSubProfileEditHeader(props: ModalSubProfileEditHeaderProps) {
  const { onDismiss, title } = props;

  return (
    <div className="modal-header">
      <h2>{title}</h2>
      {/* FIXME: when design system button is available */}
      <button onClick={() => onDismiss()} style={{ backgroundColor: "transparent" }}>
        <Icon name="Close" color={Colors.blue500} />
      </button>
    </div>
  );
}

type ModalSubProfileEditBodyProps = {
  children: ReactNode;
  hasApiError?: boolean;
};

export function ModalSubProfileEditBody(props: ModalSubProfileEditBodyProps) {
  const { children, hasApiError } = props;

  return (
    <div className="modal-body">
      {hasApiError && <AlertError />}
      {children}
    </div>
  );
}

type ModalSubProfileEditFooterProps = {
  buttonPrimary: {
    onClick: () => void;
    isDisabled: boolean;
    text: string;
  };
  buttonSecondary?: {
    onClick: () => void;
    isDisabled: boolean;
    text: string;
  };
};

export function ModalSubProfileEditFooter(props: ModalSubProfileEditFooterProps) {
  const { buttonPrimary, buttonSecondary } = props;

  // handle layout based on existence of secondary button
  const layoutClassName = buttonSecondary ? "two-buttons" : "";

  return (
    <div className={`modal-footer ${layoutClassName}`}>
      {buttonSecondary && (
        <div>
          <Button
            data-testid="modal-sub-profile-edit-footer-button-secondary"
            type="secondary"
            isFluid
            status={buttonSecondary.isDisabled ? "disabled" : "enabled"}
            onClick={buttonSecondary.onClick}
          >
            {buttonSecondary.text}
          </Button>
        </div>
      )}
      {buttonPrimary && (
        <div>
          <Button
            data-testid="modal-sub-profile-edit-footer-button-primary"
            type="primary"
            isFluid
            status={buttonPrimary.isDisabled ? "disabled" : "enabled"}
            onClick={buttonPrimary.onClick}
          >
            {buttonPrimary.text}
          </Button>
        </div>
      )}
    </div>
  );
}
